import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';

import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';

const propTypes = {
  selectedRows: PropTypes.array.isRequired,
  setBatchEditModalIsOpen: PropTypes.func.isRequired,
  setSelectedIssueIndexes: PropTypes.func.isRequired,
};

/**
 *  This is an edit button on the toolbar of the table when user multi-select rows;
 *  It sets the selected indexes; And then sets the Batch-Edit Modal window open;
 *
 *  This is the only thing it does; Nothing else;
 */
const CustomToolbarSelectBatchEdit = ({
  selectedRows,
  setBatchEditModalIsOpen,
  setSelectedIssueIndexes,
}) => {
  const handleIconButtonClick = () => {
    const selectedIssueIndexes = selectedRows.map((item) => item.original.view);
    setSelectedIssueIndexes(selectedIssueIndexes);
    setBatchEditModalIsOpen();
  };

  return (
    <Fragment>
      <Button
        component="label"
        variant="contained"
        disabled={selectedRows.length === 0}
        startIcon={<EditIcon />}
        onClick={handleIconButtonClick}>
        {intl.get('dashboard_received_history_table_button_edit')}
      </Button>
    </Fragment>
  );
};

CustomToolbarSelectBatchEdit.propTypes = propTypes;

export default CustomToolbarSelectBatchEdit;
